
import { FC } from "react";

import Icon from '@assets/icons/google';
import { Button, ButtonProps as Props } from "./Buttons";


const GoogleButton: FC<Props> = ({ ...props }) => {
  return <Button left={<Icon />} /* primary outlined */ {...props} />;
};

export default GoogleButton;